<div class="annual-plan-dialog-form-phase">
    <form [formGroup]="annualPlanForm">
        <h1 mat-dialog-title>
            {{ data.dialogTitle | translate}}
        </h1>
        <div mat-dialog-content>
            <div class="line flex flex-col" *ngIf="isLangSelectable">
                <label class="language-label">{{ 'Available_languages' | translate }}:</label>

                <div class="language-checkbox-group">
                    <mat-checkbox
                        *ngFor="let lang of availableLangs"
                        [checked]="isLangSelected(lang.id)"
                        (change)="toggleLanguage(lang.id, $event.checked)">
                        {{ lang.shortName }}
                    </mat-checkbox>
                </div>

                <mat-error *ngIf="languagesFormControl.invalid">
                    {{ 'select_at_least_one_language' | translate }}
                </mat-error>    
            </div>
            <fieldset [disabled]="isSubmitting">
                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label class="required">{{ 'Title' | translate }}</mat-label>
                        <input matInput
                               [required]="true"
                               formControlName="title"
                               class="required">
                        <mat-error *ngIf="f['title'].errors && f['title'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <!--
                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'weeks_length_16_to_52' | translate">
                        <mat-label class="required">{{ 'WeeksLength' | translate }}</mat-label>
                        <input type="number" matInput formControlName="weeksLength" autocomplete="off">
                        <mat-error *ngIf="f.weeksLength.errors && f.weeksLength.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                        <mat-error *ngIf="f.weeksLength.errors && f.weeksLength.errors.min">{{ 'Field_min_16' | translate }}</mat-error>
                        <mat-error *ngIf="f.weeksLength.errors && f.weeksLength.errors.max">{{ 'Field_max_52' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                -->
                <div class="line line-margin" *ngIf="!this.duplicateAsModel">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'AnnualPlanStartedAt' | translate }}</mat-label>
                        <input matInput
                               #startedAt
                               [required]="true"
                               [matDatepicker]="pickerStartedAt"
                               formControlName="startedAt"
                               autocomplete="off">
                        <mat-error *ngIf="f['startedAt'].errors && f['startedAt'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                        <mat-datepicker-toggle matSuffix [for]="pickerStartedAt"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStartedAt startView="year" [startAt]="startDate"></mat-datepicker>
                    </mat-form-field>
                </div>

                <!--
                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'EndedAt' | translate }}</mat-label>
                        <input matInput formControlName="endedAt" [min]="minDate" [max]="maxDate" [matDatepicker]="pickerEndedAt" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="pickerEndedAt"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEndedAt startView="year"></mat-datepicker>
                        <mat-error *ngIf="f.endedAt.errors && f.endedAt.errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                -->

                <div class="line line-margin">
                    <duration-control [(value)]="duration"
                                      [label]="'WeeklyWorkingTime' | translate"
                                      [displayMode]="'hm'"
                                      [min]="60"
                    >
                    </duration-control>
                </div>

                <div class="line line-margin">
                    <mat-form-field>
                        <mat-label>{{ 'Comment' | translate }}</mat-label>
                        <textarea matInput cdkTextareaAutosize formControlName="comment"></textarea>
                        <mat-error *ngIf="f['comment'].errors">{{ 'validator.comment.max_length' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
        <mat-dialog-actions>

            <button mat-button mat-dialog-close tabindex="-1">
                {{ 'Cancel' | translate}}
            </button>

            <button mat-raised-button (click)="submitForm()" color="accent">
                {{ (data.formSaveActionTitle ? data.formSaveActionTitle : 'Add') | translate}}
            </button>

        </mat-dialog-actions>
    </form>
</div>
